import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { StingrayCommonModule } from '@modules/common/common.module';
import { NavClientPickerComponent } from '@modules/navigation/components/nav-client-picker/nav-client-picker.component';
import { NavEnvMessageComponent } from '@modules/navigation/components/nav-env-message/nav-env-message.component';
import { NavEnvPickerComponent } from '@modules/navigation/components/nav-env-picker/nav-env-picker.component';
import { NavHeaderComponent } from '@modules/navigation/components/nav-header/nav-header.component';
import { NavLayoutComponent } from '@modules/navigation/components/nav-layout/nav-layout.component';
import { NavNewTabComponent } from '@modules/navigation/components/nav-new-tab/nav-new-tab.component';
import { NavPhoneCallBannerComponent } from '@modules/navigation/components/nav-phone-call-banner/nav-phone-call-banner.component';
import { NavSidebarComponent } from '@modules/navigation/components/nav-sidebar/nav-sidebar.component';
import { NavUserMenuComponent } from '@modules/navigation/components/nav-user-menu/nav-user-menu.component';

@NgModule({
    declarations: [
        NavLayoutComponent,
        NavHeaderComponent,
        NavSidebarComponent,
        NavClientPickerComponent,
        NavNewTabComponent,
        NavUserMenuComponent,
        NavEnvPickerComponent,
        NavEnvMessageComponent,
        NavPhoneCallBannerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        //Start Angular Material
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatSelectModule,
        MatTooltipModule,
        MatIconModule,
        //End Angular Material
        RouterModule,
        StingrayCommonModule
    ]
})
export class NavigationModule {
}
